module.exports = __webpack_public_path__ + "img/06.e850dc7a.png";